import { Button, ButtonProps } from "@mui/material";

interface CustomButtonProps extends ButtonProps {
  children: React.ReactNode;
}

const CustomButton = ({
  children,
  fullWidth = true,
  ...props
}: CustomButtonProps) => {
  return (
    <Button
      {...props}
      fullWidth={fullWidth}
      variant="outlined"
      sx={{
        height: "40px",
        minWidth: "80px",
        padding: "0 12px",
        borderColor: "primary.main",
        color: "primary.main",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "primary.main",
          color: "primary.contrastText",
          borderColor: "primary.main",
        },
      }}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
